import { ts } from '_core';

/*
 * Format on the data object naming:
 * Before: weights|earnings_yield
 * After: Earnings Yield
 */
export const prepareWeigtsVsTimeData = (localData: ts.types.widgets.TableData) => {
  const newData = localData.map((item) => {
    const newItem = { date: item.build_date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key !== 'date' && key !== 'build_date') {
        const jointKey = key.split('|').slice(1, key.length).join(' + ');
        newItem[jointKey] = item[key];
      }
    });
    return newItem;
  });
  return newData;
};
